import { lazy } from "react";

function load(code) {
  switch (code) {
    case "user/list":
      return lazy(() => import("views/user/list"));
    case "user/editor":
      return lazy(() => import("views/user/editor"));
    case "role/list":
      return lazy(() => import("views/role/list"));
    case "role/editor":
      return lazy(() => import("views/role/editor"));
    default:
      return null;
  }
}
export default load;
